module.exports = __webpack_public_path__ + "img/avatar-49.763687d0.png";